import React, { useCallback, useRef, useState } from 'react'

import { Button, T, Tooltip } from 'src/govwell-ui'

const TRUNCATION_BUFFER_PX = 1

type Props = {
  prompt: string
  onSelect?: (prompt: string) => void
}

const PromptButton = ({ prompt, onSelect }: Props) => {
  const textRef = useRef<HTMLElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  const handleClick = useCallback(() => {
    onSelect?.(prompt)
  }, [onSelect, prompt])

  const handleMouseEnter = useCallback(() => {
    const el = textRef.current
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth + TRUNCATION_BUFFER_PX)
    }
  }, [])

  const button = (
    <Button size="sm" variant="default" onClick={handleClick} className="max-w-full min-w-0">
      <T.Body ref={textRef} className="min-w-0 truncate">
        {prompt}
      </T.Body>
    </Button>
  )

  return (
    <div className="max-w-full min-w-0" onMouseEnter={handleMouseEnter}>
      {isTruncated ? (
        <Tooltip content={prompt}>
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      )}
    </div>
  )
}

export default React.memo(PromptButton)
